import { IconButton, InputBase, Paper } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { phoneInputStyles } from './styles';
import { PhoneNumberInputProps } from './types';

export const PhoneNumberInput = ({ dialNumber, onNumberChange, onClearNumber }: PhoneNumberInputProps) => (
  <Paper sx={phoneInputStyles.numberPaper}>
    <InputBase
      sx={phoneInputStyles.numberInput}
      size="small"
      value={dialNumber}
      onChange={onNumberChange}
      placeholder="Teléfono"
      inputProps={{ 'aria-label': 'número de teléfono' }}
    />
    {dialNumber && (
      <IconButton onClick={onClearNumber} size="small" sx={phoneInputStyles.clearButton}>
        <Clear fontSize="small" />
      </IconButton>
    )}
  </Paper>
);
